import {Box} from 'src/design/atoms/Box';
import React from 'react';

import type {PersonnelResponse} from 'src/api/ProactApiClient';
import {Description} from 'src/design/atoms/Description';
import {Subtitle} from 'src/design/atoms/Typography';
import {QrCodeGenerator} from 'src/design/organisms/QrCodeGenerator';
import {PathUtility} from 'src/shared/constants/PathBuilder';

export interface PersonnelQRCodeTabProps {
  id?: number;
  vendorId?: number;
  item?: PersonnelResponse;
}
export const PersonnelQRCodeTab: React.FC<PersonnelQRCodeTabProps> = ({
  id,
  vendorId,
  item,
}) => {
  const resolvedId = id ?? item?.id;
  const resolvedVendorId = vendorId ?? item?.vendorId;

  const QRCodeUrl = resolvedVendorId
    ? `${window.location.hostname}${PathUtility.VendorPersonnelView(
        String(resolvedId),
        String(resolvedVendorId),
        'overview'
      )}`
    : `${window.location.hostname}${PathUtility.PersonnelView(
        String(resolvedId),
        'overview'
      )}`;

  return (
    <>
      <Box mb="md">
        <Subtitle text={`${item?.name} QR Code`} />
        <Description text="Use this QR Code to access this personnel record. Scanning this QR Code will give you the specific website URL to this web page." />
      </Box>
      <QrCodeGenerator
        title={`${item?.name} Personnel QR Code`}
        value={QRCodeUrl}
      />
    </>
  );
};
